import React, { Component } from 'react';
import PropTypes from 'prop-types';
import prettyBytes from 'pretty-bytes';

import PaperClipIcon from './PaperClipIcon';
import { COLORS } from '../constants/styles';
import { SEND_STATUS } from '../constants/message';
import { isCurrentUserMessage } from '../utils/message';

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '55px',
        maxWidth: '210px',
    },
    pointer: {
        cursor: 'pointer',
    },
    logo: {
        marginRight: '8px',
        padding: '5px 2px 2px',
        maxWidth: '34px',
        width: '34px',
        minWidth: '19px',
        flexGrow: '1',
        height: 'auto',
    },
    text: {
        flexGrow: '2',
        userSelect: 'none',
    },
    titleContainer: {
        display: 'flex',
    },
    title: {
        fontSize: '14px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
        margin: '0px',
        maxWidth: '62px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    size: {
        fontSize: '12px',
        whiteSpace: 'nowrap',
        lineHeight: '1.0',
    },
};

export default class FileMessage extends Component {
    static propTypes = {
        _clientId: PropTypes.number,
        className: PropTypes.string,
        dispatch: PropTypes.func,
        mediaSize: PropTypes.number,
        mediaUrl: PropTypes.string.isRequired,
        role: PropTypes.string,
        sendStatus: PropTypes.string,
        authorId: PropTypes.string.isRequired,
        currentUser: PropTypes.object.isRequired,
    };

    _getFileInfo() {
        const { mediaSize, mediaUrl, role, currentUser, authorId } = this.props;

        let fileName = mediaUrl;

        try {
            fileName = new URL(mediaUrl).pathname.split('/').pop();
        } catch (ignored) {
            // before file becomes a full url the above will fail (while uploading)
        }

        const ext = fileName.split('.').pop().toLowerCase();
        fileName = fileName.split('.').shift();

        try {
            fileName = decodeURIComponent(fileName);
        } catch (e) {
            // do nothing, use fileName as-is
        }

        let fileSize;

        const sizeStyles = {
            ...styles.size,
        };

        if (!isCurrentUserMessage({ role, authorId }, currentUser._id)) {
            sizeStyles.color = COLORS.GRAY_CADET;
        }

        if (mediaSize) {
            fileSize = prettyBytes(mediaSize).toUpperCase();
        }

        return (
            <div style={styles.text}>
                <div
                    className="file-name"
                    style={styles.titleContainer}
                    data-content-end={`${fileName.substr(-5)}.${ext}`}
                >
                    <p style={styles.title}>{fileName.substr(0, fileName.length - 5)}</p>
                </div>
                {fileSize ? <div style={sizeStyles}>{fileSize}</div> : null}
            </div>
        );
    }

    onClick = (e) => {
        const { mediaUrl, sendStatus } = this.props;

        if (sendStatus === SEND_STATUS.SENT) {
            e.preventDefault();
            e.stopPropagation();

            return window.open(mediaUrl, '_blank');
        }
    };

    render() {
        const { className, role, authorId, currentUser, sendStatus } = this.props;
        let containerStyles = styles.container;

        if (sendStatus === SEND_STATUS.FAILED || sendStatus === SEND_STATUS.SENT) {
            containerStyles = {
                ...containerStyles,
                ...styles.pointer,
            };
        }

        return (
            <div style={containerStyles} className={className} onClick={this.onClick}>
                <div style={styles.logo}>
                    <PaperClipIcon isFromCurrentUser={isCurrentUserMessage({ role, authorId }, currentUser._id)} />
                </div>
                {this._getFileInfo()}
            </div>
        );
    }
}
